import {
  binaryMetric,
  currencyMetric,
  filter,
  metric,
  toCurrency,
  valueSet,
} from 'utils/metrics/constructors';
import nightOfMetrics from 'utils/metrics/nightOfMetrics';

const AllBookings = binaryMetric(
  'Reservations',
  'PLUS',
  metric(
    'Reservations',
    'NIGHT_OF_BOOKINGS_COUNT',
    'Number of reservations',
    'number',
    null,
    filter({ operation: 'AND', valueSet: [valueSet('IS_CANCELLED', [0])] })
  ),
  metric('', 'IMPORTED_BOOKING_COUNT')
);

const AllCancellations = binaryMetric(
  'Cancellations',
  'PLUS',
  metric('Reservations', 'NIGHT_OF_CANCELLATION_COUNT', 'Number of cancellatiosn', 'number', null),
  metric('', 'IMPORTED_VISIT_CANCELLATIONS')
);
const AllNoShows = binaryMetric(
  'No-shows',
  'PLUS',
  metric('', 'VISIT_NO_SHOWS'),
  metric('', 'IMPORTED_VISIT_NO_SHOWS')
);
const BookByEmail = metric(
  'Book by emails',
  'BOOK_BY_EMAIL',
  'Number of book by emails intiated for a guest'
);
const BookingCount = metric('Reservations', 'BOOKING_COUNT', 'Number of reservations made');
const BookingCoversCount = metric(
  'Reserved covers',
  'BOOKING_COVERS_BOUGHT',
  'Number of covers booked as part of the reservations.'
);
const BookingSupplementCount = metric(
  'Sold items',
  'BOOKING_SUPPLEMENT_COUNT',
  'Number of add-ons booked as part of the reservations.'
);
const BookingGrossSales = currencyMetric(
  'Sales',
  'BOOKING_GROSS_AMOUNT_CHARGED_LOCAL_CENTS',
  'Total sales made'
);
const BookingSoldExperiencePrice = currencyMetric(
  'Experience sales',
  'BOOKING_PURCHASED_EXPERIENCE_LOCAL_CENTS',
  'Gross value of experiences sold, including un-paid purchases.'
);
const BookingSoldSupplementPrice = currencyMetric(
  'Supplement sales',
  'BOOKING_PURCHASED_SUPPLEMENT_LOCAL_CENTS',
  'Gross value of add-ons sold, including un-paid purchases.'
);
const GrossPayments = currencyMetric(
  'Gross sales',
  'BOOKING_PAYMENT_PROCESSED_LOCAL_CENTS',
  "Gross sales charged on guest's credit card."
);
const ImportedBookingCount = metric(
  'Imported reservations',
  'IMPORTED_BOOKING_COUNT',
  'Reservations imported into Tock from another system'
);
const ImportedVisitCancellations = metric(
  'Imported cancellations',
  'IMPORTED_VISIT_CANCELLATIONS',
  'Number of cancellations imported from another system'
);
const ImportedVisitNoShows = metric(
  'Imported no-shows',
  'IMPORTED_VISIT_NO_SHOWS',
  'Number of no-shows imported from another system'
);
const ImportedWalkinCount = metric(
  'Imported walk-ins',
  'IMPORTED_WALKIN_COUNT',
  'Number of walk-ins imported from another system'
);
const IncomePerCover = binaryMetric(
  'Income per cover',
  'QUOT',
  nightOfMetrics.ServicedPayments,
  nightOfMetrics.NightOfSoldCovers,
  'Income per cover on the day of service.',
  'currency',
  toCurrency
);
const NetPayments = currencyMetric(
  'Net sales',
  'BOOKING_NET_AMOUNT_PROCESSED_LOCAL_CENTS',
  'Net payments is calculated as Gross Sales - Refunds'
);
const Refunds = currencyMetric(
  'Refunds',
  'BOOKING_REFUND_ISSUED_LOCAL_CENTS',
  'Refunds on guests credit card. This includes refunds generated during transfer.'
);
const VisitNoShows = metric(
  'Visit no-shows',
  'VISIT_NO_SHOWS',
  'Number of times the guest has no-showed on reservations or tickets'
);
const VisitTotalVisits = metric(
  'Total visits',
  'VISIT_TOTAL_VISITS',
  'Number of reservations the guest has arrived for'
);

export default {
  AllBookings,
  AllCancellations,
  AllNoShows,
  BookByEmail,
  BookingCount,
  BookingCoversCount,
  BookingSupplementCount,
  BookingGrossSales,
  BookingSoldExperiencePrice,
  BookingSoldSupplementPrice,
  GrossPayments,
  ImportedBookingCount,
  ImportedVisitCancellations,
  ImportedVisitNoShows,
  ImportedWalkinCount,
  IncomePerCover,
  NetPayments,
  Refunds,
  VisitNoShows,
  VisitTotalVisits,
  ...nightOfMetrics,
};
